import { makeObservable, observable, action, computed, runInAction } from "mobx";
import { SingletonClass } from "@/app/utils/SingletonClass";
import { getInitData, getUserId, getUser, type TelegramUser } from "@/app/network/utils/TelegramAuthUtil";


export class TelegramAuthController extends SingletonClass {
  private static _instance: TelegramAuthController;

  initData: string | null = null;
  userId: number | null = null;
  user: TelegramUser | null = null;
  isLoading = true;

  static getInstance(): TelegramAuthController {
    if (!TelegramAuthController._instance) {
      TelegramAuthController._instance = new TelegramAuthController();
    }
    return TelegramAuthController._instance;
  }

  constructor() {
    super();
    makeObservable(this, {
      initData: observable,
      userId: observable,
      user: observable,
      isLoading: observable,
      isAvailable: computed,
      loadAuthData: action,
    });
  }

  loadAuthData(): void {
    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const data = getInitData();
      const id = getUserId();
      const userData = getUser();

      runInAction(() => {
        this.initData = data;
        this.userId = id;
        this.user = userData;
        this.isLoading = false;
      });
    } catch (error) {
      console.error("Failed to load Telegram auth data:", error);
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

   setUser(user: TelegramUser): void {
        runInAction(() => {
            this.user = user;
        });
    }

  get isAvailable(): boolean {
    return this.initData !== null;
  }
}
